import React from 'react'
import Icon from '../../../ui/Icon/Icon'

function FeedCopyRow({ label, value, copyId, copiedId, onCopy, disabled = false }) {
  const isCopied = copiedId === copyId

  return (
    <div className="XLSFeedPopUp-FeedRow">
      <span className="XLSFeedPopUp-FeedRowLabel">{label}</span>
      <div className="XLSFeedPopUp-FeedRowField">
        <input
          type="text"
          className="XLSFeedPopUp-FeedInput"
          readOnly
          disabled={disabled}
          value={value}
        />
        <button
          type="button"
          className="XLSFeedPopUp-CopyButton"
          title={isCopied ? 'Скопійовано' : 'Скопіювати'}
          disabled={disabled || !value}
          onClick={onCopy}
        >
          <Icon name={isCopied ? 'check' : 'copy'} weight="regular" size={14} />
        </button>
      </div>
    </div>
  )
}

export default FeedCopyRow
